/**
 * Purpose of ensureCachedVideoElement is to create
 * HTMLVideoElement and store it in cache for later use.
 */
const windowCache = typeof window !== 'undefined'
    ? window.name === 'fw-iframe'
        ? window.parent
        : window
    : {};
if (!windowCache['_fwn_playerVideo']) {
    windowCache['_fwn_playerVideo'] = {};
}
const createVideoElement = (options) => {
    const videoElement = (typeof window !== 'undefined' ? document.createElement('video') : {});
    const opts = Object.assign({ autoplay: true, muted: true, playsInline: true }, options);
    videoElement.autoplay = !!opts.autoplay;
    videoElement.muted = !!opts.muted;
    videoElement.playsInline = !!opts.playsInline;
    videoElement.tabIndex = 0;
    //   //if (subtitles) setSubtitles(videoElement, subtitles)
    return videoElement;
};
export const discardCachedVideoElement = (key) => {
    windowCache['_fwn_playerVideo'][key] = undefined;
};
export const ensureCachedVideoElement = (options) => {
    return (windowCache['_fwn_playerVideo'][options.key] ||
        (windowCache['_fwn_playerVideo'][options.key] = createVideoElement(options)));
};
